"use strict";

require("./fill");

require("./padEnd");

require("./padStart");

require("./setPrototypeOf");

require("./textDecoder");

require("./textEncoder");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util/polyfill/index.js
// module id = 391
// module chunks = 0